import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('Auth guard triggered for route:', state.url);
  console.log('Auth service initialization status:', authService.isAuthInitialized);
  
  const currentUser = authService.currentUser;
  console.log('Current user from auth service:', currentUser ? {
    uid: currentUser.uid,
    email: currentUser.email,
    role: currentUser.role,
    displayName: currentUser.displayName
  } : 'null');
  
  if (currentUser && currentUser.uid) {
    console.log('✅ User authenticated, allowing access to:', state.url);
    console.log('User details - UID:', currentUser.uid, 'Email:', currentUser.email, 'Role:', currentUser.role);
    return true;
  } else {
    console.log('❌ User not authenticated, redirecting to login');
    console.log('Auth check failed - currentUser:', !!currentUser, 'hasUID:', !!(currentUser?.uid));
    router.navigate(['/login'], { 
      queryParams: { returnUrl: state.url }
    });
    return false;
  }
};